import React from 'react';
import { useSearchParams } from 'react-router-dom';

export default function VroomPassReturn() {
  const [params] = useSearchParams();
  const cancelled = params.get('status') === 'cancelled';
  return <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#101217', color: '#fff', padding: 24 }}>
    <section style={{ maxWidth: 480, padding: 32, border: '1px solid #343840', borderRadius: 24 }}>
      <p style={{ color: '#FFD447', fontWeight: 800 }}>VROOM PASS</p>
      <h1>{cancelled ? 'Zakup przerwany' : 'Sprawdź swój Pass w aplikacji'}</h1>
      <p>{cancelled ? 'Możesz wrócić do zakupu w dowolnej chwili.' : 'Po otrzymaniu potwierdzenia płatności dodamy zakupiony czas dostępu. Jeśli Pass był aktywny, przedłużymy jego ważność.'}</p>
      <p>Zakup jest jednorazowy. Kolejny okres kupujesz samodzielnie, bez automatycznego odnawiania.</p>
      <a href="vroom://seasons/current" style={{ display: 'inline-block', padding: '14px 20px', borderRadius: 12, background: '#FFD447', color: '#111', fontWeight: 800, textDecoration: 'none' }}>Otwórz VROOM</a>
    </section>
  </main>;
}
